import { createMeasurement, type MeasurementProps } from './createMeasurement';

export type TemperatureProps = MeasurementProps<'temperature'>;

/**
 * A temperature, in Celsius or Fahrenheit.
 *
 * The one affine conversion in the set: the scales have different zero points, so a temperature
 * cannot be scaled the way a distance can. Passing the wrong `valueUnit` is therefore wrong by an
 * offset as well as a factor.
 */
const Temperature = createMeasurement('temperature', 'Temperature');

export default Temperature;
